import {createInitAjaxFormMap} from "./index";
import {default as initMap, setMarker, activateMarker, loadGoogleMapsAPI, setDefaultMarkerStyle, showInfoBoxByMarker} from "../google-map";

export function apiLoaded(){
    return loadGoogleMapsAPI();
}

export const initAjaxFormMap = createInitAjaxFormMap({initMap, setMarker, activateMarker, setDefaultMarkerStyle, showInfoBoxByMarker});